var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPinRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1366,
    zoomAndPan: "magnify",
    viewBox: "0 0 1024.5 1307.999939",
    height: 1744,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#cf5443",
    d: "M 999.164062 395.53125 L 999.164062 395.371094 C 935.027344 1.042969 512.597656 4.375 508.3125 4.375 C 507.261719 4.214844 506.199219 4.160156 505.136719 4.214844 C 463.230469 4.214844 78.582031 14.695312 16.828125 395.371094 C -2.960938 526.53125 21.386719 660.546875 86.042969 776.367188 C 196.101562 973.472656 338.773438 1150.496094 507.996094 1299.917969 C 677.132812 1150.453125 819.742188 973.4375 929.789062 776.367188 C 994.566406 660.648438 1018.972656 526.65625 999.164062 395.53125 Z M 507.996094 701.597656 C 463.394531 701.582031 419.800781 688.339844 382.726562 663.546875 C 345.652344 638.757812 316.761719 603.527344 299.707031 562.316406 C 282.65625 521.105469 278.203125 475.761719 286.921875 432.023438 C 295.636719 388.285156 317.128906 348.109375 348.675781 316.585938 C 380.226562 285.058594 420.414062 263.597656 464.160156 254.910156 C 507.90625 246.226562 553.246094 250.707031 594.445312 267.789062 C 635.644531 284.871094 670.851562 313.785156 695.617188 350.878906 C 720.382812 387.972656 733.59375 431.574219 733.578125 476.175781 C 733.472656 535.957031 709.667969 593.257812 667.382812 635.515625 C 625.09375 677.773438 567.777344 701.535156 507.996094 701.597656 Z M 507.996094 701.597656 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinRed);
export default __webpack_public_path__ + "static/media/pin_red.1143ece9f0ac5af0012f220a5b9060d4.svg";
export { ForwardRef as ReactComponent };